{
  "additional_products": "Extra producten",
  "apply": "Toepassen",
  "arriving_at": "Aankomst bij",
  "available": "Beschikbaar",
  "available_for_single_use": "Boekbaar voor alleengebruik",
  "back": "Terug",
  "back_to_payment": "Terug naar betaling",
  "book_now": "Nu boeken",
  "booking_confirmed_text": "Je boeking is bevestigd.",
  "booking_confirmed_title": "Bedankt voor het boeken bij ons!",
  "cabin_count": "{{count}} hutten",
  "cabin_count_one": "{{count}} hut",
  "cabin_count_zero": "Selecteer",
  "cabin_x": "Hut {{ index}}",
  "chat_button_text": "💬 Kunnen we je helpen?",
  "checkout": "Afrekenen",
  "choose_preferred_ship": "Kies het gewenste schip",
  "choose_preferred_ship_one": "Schip",
  "choose_preferred_ship_other": "Kies voorkeursschip",
  "choose_ship": "Kies schip",
  "chosen_ship": "Gekozen schip",
  "close": "Sluit",
  "creating_your_booking": "Uw boeking wordt verwerkt",
  "credit_card_extra_charge": "Voor creditcards buiten de EU worden 3% transactiekosten in rekening gebracht.",
  "current_voucher_code": "Code: {{ code}}",
  "date_format": "DD-MM-YYYY",
  "date_format_short": "D MMM",
  "date_range": "{{ start }} t/m {{ end }}",
  "depart_from": "Vertrek van",
  "departure_date": "Vertrekdatum",
  "discount": "Korting",
  "discount_tooltip": "Als een datum oranje is gemarkeerd, betekent dit dat er een korting beschikbaar is voor de reis die vertrekt op die dag. Klik op de gemarkeerde datum om de details van de korting te bekijken.",
  "gender_female": "Vrouw",
  "gender_male": "Man",
  "gender_none": "",
  "have_coupon_code": "Kortingscode?",
  "insurance": "Verzekering",
  "invalid_voucher_code": "Ongeldige vouchercode",
  "loading": "Laden…",
  "max_x_persons_one": "max {{ count }} persoon",
  "max_x_persons_other": "max {{ count }} personen",
  "next": "Volgende",
  "no_cabins_available": "Geen hutten beschikbaar",
  "no_diet": "Geen dieet",
  "no_ship_available": "Geen schip beschikbaar.",
  "number_of_products": "Aantal producten",
  "on_request": "Op aanvraag",
  "on_request_tooltip": "“Beschikbaar op aanvraag” betekent dat we de beschikbaarheid om verschillende redenen moeten controleren; we zullen je boeking binnen 48 uur bevestigen of alternatieven voorstellen.",
  "only_x_left_one": "Nog {{ count }} beschikbaar",
  "only_x_left_other": "Nog {{ count }} beschikbaar",
  "passenger": "Passagiers",
  "people_count": "{{count}} personen",
  "people_count_one": "{{count}} persoon",
  "personal_information_additional": "Persoonlijke gegevens - Andere passagier {{index}}",
  "personal_information_main": "Persoonlijke gegevens - Hoofdboeker",
  "price": "Prijs",
  "price_overview": "Prijsoverzicht",
  "price_per_person": "{{ price }} p.p.",
  "price_starting_from": "vanaf {{ price }}",
  "prices_and_availability": "Prijzen & beschikbaarheid",
  "processing_payment": "Betaling verwerken",
  "product_name": "Productnaam",
  "read_less": "Minder lezen",
  "read_more": "Meer lezen",
  "remove_coupon_code": "Kortingscode verwijderen?",
  "search_for_a_tour": "Een reis zoeken",
  "select_date": "Selecteer alstublieft een datum",
  "select_your_cabins": "Selecteer alstublieft uw hut(ten)",
  "something_went_wrong": "Er is iets mis gegaan",
  "start_booking": "Begin met boeken",
  "subtotal": "Subtotaal",
  "total": "Totaal",
  "unavailable": "Volgeboekt",
  "unknown": "Onbekend",
  "unsupported_browser_description": "Update uw browser alstublieft.",
  "unsupported_browser_title": "Uw browser wordt niet ondersteund.",
  "vat": "BTW ({{ percentage }}%)",
  "voucher_placeholder": "Kortingscode",
  "x_days_one": "{{ count }} dag",
  "x_days_other": "{{ count }} dagen"
}
